"use client";

import AddIcon from '@mui/icons-material/Add';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import { Box, Typography, Button } from '@mui/material';
import { useTranslations } from 'next-intl';
import React from 'react';
import ApiDocsLinkButton from '@/components/ApiKeys/ApiDocsLinkButton';
import { colors, typography } from '@/theme/colors';
interface EmptyStateProps {
  onCreateClick: () => void;
}
const EmptyState: React.FC<EmptyStateProps> = ({
  onCreateClick
}) => {
  const t = useTranslations('apiKeys');
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    py: 8,
    px: 2,
    animation: 'fadeIn 0.4s ease-out',
    '@keyframes fadeIn': {
      from: {
        opacity: 0
      },
      to: {
        opacity: 1
      }
    }
  }} data-sentry-element="Box" data-sentry-component="EmptyState" data-sentry-source-file="EmptyState.tsx">
      <VpnKeyOutlinedIcon sx={{
      fontSize: 48,
      color: colors.text.placeholder,
      mb: 3
    }} data-sentry-element="VpnKeyOutlinedIcon" data-sentry-source-file="EmptyState.tsx" />
      
      <Typography sx={{
      ...typography.presets.sectionTitle,
      color: colors.text.primary,
      mb: 1.5
    }} data-sentry-element="Typography" data-sentry-source-file="EmptyState.tsx">
        {t('emptyTitle')}
      </Typography>
      
      <Typography sx={{
      ...typography.presets.bodyDefault,
      color: colors.text.tertiary,
      maxWidth: 400,
      mb: 4
    }} data-sentry-element="Typography" data-sentry-source-file="EmptyState.tsx">
        {t('emptyBody')}
      </Typography>
      
      <Button variant="contained" startIcon={<AddIcon />} onClick={onCreateClick} sx={{
      bgcolor: colors.primary.main,
      textTransform: 'none',
      minWidth: '44px',
      minHeight: '44px',
      px: 3,
      py: 1.5,
      transition: 'all 0.15s ease',
      '&:hover': {
        bgcolor: colors.primary.hover,
        transform: 'translateY(-1px)'
      },
      '&:active': {
        transform: 'scale(0.98)'
      }
    }} data-sentry-element="Button" data-sentry-source-file="EmptyState.tsx">
        {t('emptyCta')}
      </Button>

      <ApiDocsLinkButton label="Docs" variant="text" sx={{
      textTransform: 'none',
      minWidth: '44px',
      minHeight: '44px',
      color: colors.primary.main,
      mt: 1,
      '&:hover': {
        bgcolor: 'transparent',
        textDecoration: 'underline'
      }
    }} data-sentry-element="ApiDocsLinkButton" data-sentry-source-file="EmptyState.tsx" />
    </Box>;
};
export default EmptyState;